/* eslint-disable no-unused-vars */
import { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';

const useDiscountsData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getDiscounts= async () => {
        const response = await axios.get("/api/kinto/discounts");
        setState(prevState => ({
            ...prevState,
            discounts: response?.data.share
        }))
    }

    return {
        discounts: state.discounts,
        getDiscounts,
    };
}

export default useDiscountsData;